import React, { ReactElement, useState } from 'react';
import MuiTable from 'components/molecules/MuiTable';
import { Button, CircularProgress } from '@material-ui/core';
import format from 'date-fns/format';
import localeEs from 'date-fns/locale/es';
import { MUIDataTableColumnDef, MUIDataTableOptions } from 'mui-datatables';
import textLabels from 'utils/MUIDataTableTextLabels';
import usePurchaseOrders from 'hooks/usePurchaseOrders';
import PurchaseOrderModal from '../PurchaseOrderModal/PurcharseOrderModal';
import { IPurchaseDetail, IPurchaseOrderList } from 'interfaces/purchaseOrders.interface';
import useCrossingInvoices from 'hooks/useCrossingInvoices';
import { download } from 'utils/downloadXlsx';
import useCustomSnackbar from 'hooks/useCustomSnackbar';

interface Props {
  isLoading: boolean;
  purchaseOrders: IPurchaseOrderList[];
}
export default function PurchaseOrdersList({ isLoading, purchaseOrders }: Props): ReactElement {
  const { getPurchaseOrdersByNumber } = usePurchaseOrders();

  const [purchaseDetail, setPurchaseDetail] = useState<IPurchaseDetail>({
    createAt: '',
    ocNumber: '',
    orders: []
  });
  const [isLoadingD, setIsLoadingD] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const { getInvoicesByOc } = useCrossingInvoices();
  const { showNotistack } = useCustomSnackbar();

  const getPurchaseDetail = (ocNumber: string) => {
    const ocNumberInt = parseInt(ocNumber, 10);
    getPurchaseOrdersByNumber(ocNumberInt)
      .then((purcharseDetail: IPurchaseDetail) => {
        setPurchaseDetail(purcharseDetail);
      })
      .catch(() => {
        // TODO redireccionar en 403
      })
      .finally(() => {
        //setIsLoading(false);
      });
  };

  const columns: MUIDataTableColumnDef[] = [
    {
      name: 'id',
      label: 'id',
      options: {
        display: 'false'
      }
    },
    {
      name: 'id',
      label: 'Número de orden'
    },
    {
      name: 'userName',
      label: 'Dropshipper'
    },
    {
      name: 'createAt',
      label: 'Fecha del pedido',
      options: {
        customBodyRender: (value) => {
          const dateOC = format(new Date(value), "dd MMMM 'a las' HH:mm", {
            locale: localeEs
          });

          return dateOC;
        }
      }
    },
    {
      name: 'id',
      label: 'Detalle',
      options: {
        customBodyRender: (value) => (
          <Button
            variant="outlined"
            size="small"
            color="primary"
            onClick={async () => {
              getPurchaseDetail(value);
              setOpenModal(true);
            }}
          >
            Ver
          </Button>
        )
      }
    }
  ];

  const options: MUIDataTableOptions = {
    textLabels,
    download: false,
    filter: false,
    print: false,
    selectableRowsHeader: true,
    selectableRows: 'multiple',
    viewColumns: false,
    customToolbarSelect: (selected) => (
      <Button
        variant="contained"
        color="primary"
        style={{ marginRight: 8 }}
        disabled={isLoadingD}
        onClick={() => {
          getXlsx(selected);
        }}
      >
        {isLoadingD && (
          <CircularProgress size={24} style={{ marginRight: 10, width: 16, height: 16, position: 'relative' }} />
        )}
        DESCARGAR
      </Button>
    )
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setPurchaseDetail({
      createAt: '',
      ocNumber: '',
      orders: []
    });
  };

  const getXlsx = async (selected: {
    data: {
      index: number;
      dataIndex: number;
    }[];
    lookup: {
      [key: number]: boolean;
    };
  }) => {
    setIsLoadingD(true);
    try {
      const orders: any = [...purchaseOrders];
      const data = selected.data.map((i) => {
        return orders[i.dataIndex].id || purchaseOrders[i.dataIndex].ocNumber;
      });

      const response = await getInvoicesByOc(data.join(','));
      if (response.status) {
        download(response.base64, 'ordenesCompra.xlsx');
      } else {
        showNotistack({ message: response.msg ? response.msg : 'Ocurrio un error' });
      }
      setIsLoadingD(false);
    } catch (error) {
      setIsLoadingD(false);
      showNotistack({ message: 'Ocurrio un error' });
    }
  };
  return (
    <div>
      <MuiTable
        title="Ordenes de compra"
        isLoading={isLoading}
        columns={columns}
        data={purchaseOrders}
        options={options}
      />
      <PurchaseOrderModal openModal={openModal} purchaseDetail={purchaseDetail} closeModal={handleCloseModal} />
    </div>
  );
}
